import * as React from 'react';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled, useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import { Outlet, useNavigate } from 'react-router-dom';
import CuentaPopover from './CuentaPopover';
import Icon from '@mdi/react';
import { img } from '../Utils';
import metadataJson from '../../metadata.json';

import { AppContext } from '../../App';
import { mdiCarClock } from '@mdi/js';
import ComandosSimulacion from '../../pages/simulacion/ComandosSimulacion';

const drawerWidth = 300;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(2),
        width: '100%',
        //width: `calc(100% - ${drawerWidth}px)`,
        // transition: theme.transitions.create('margin', {
        //     easing: theme.transitions.easing.sharp,
        //     duration: theme.transitions.duration.leavingScreen,
        // }),
        //marginLeft: `-${drawerWidth}px`,
        // ...(open && {
        //     transition: theme.transitions.create('margin', {
        //         easing: theme.transitions.easing.easeOut,
        //         duration: theme.transitions.duration.enteringScreen,
        //     }),
        //     marginLeft: 0,
        // }),
    }),
);

const AppBar = styled(MuiAppBar, { shouldForwardProp: (prop) => prop !== 'open', })
    (({ theme, open }) => ({
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            //width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: `${drawerWidth}px`,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    }));

const DrawerHeader = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    //...theme.mixins.toolbar,
    minHeight: 64,
    //justifyContent: 'flex-end',
}));

const MenuAppBar = (props) => {
    const theme = useTheme();
    const appContext = React.useContext(AppContext);
    const { cuenta, tieneCuentaRoles } = appContext;

    const [open, setOpen] = React.useState(false);
    const [cuentaAnchorEl, setCuentaAnchor] = React.useState(null);

    const navigate = useNavigate();

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleItemClick = (path) => event => {
        navigate(`/${path}`)
        setOpen(false);
    }

    return (
        <>
            <CuentaPopover anchorEl={cuentaAnchorEl} onClose={() => setCuentaAnchor(null)} />
            <Box sx={{ display: 'flex' }}>
                <AppBar position="fixed" open={open}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            // sx={{ mr: 2, ...(open && { display: 'none' }) }}>
                            sx={{ mr: 2 }}>
                            <MenuIcon />
                        </IconButton>
                        <Box sx={{ flexGrow: 1 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                                <img src={img("/images/pase_letras_logo_white.svg")} alt="logo pase" style={{ height: 20 }} />
                                <Typography variant="h6" component="div">
                                    Estacionamientos
                                </Typography>
                            </Box>
                            <Typography variant="body2" component="div">Consola de operación</Typography>
                        </Box>
                        {cuenta.modoSimulacion &&
                            <ComandosSimulacion />
                        }
                        <IconButton
                            onClick={(event) => setCuentaAnchor(event.currentTarget)}
                            size="large"
                            edge="end"
                            color="inherit"
                            aria-label="cuenta del usuario">
                            <AccountCircle />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Drawer
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                            backgroundColor: '#F0F6EB',
                        },
                    }}
                    //variant="persistent"
                    anchor="left"
                    open={open}
                    onClose={() => setOpen(false)}>
                    <DrawerHeader>
                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', flexGrow: 1, justifyContent: 'center' }}>
                            <img src={img("/images/pase_letras_logo.svg")} alt="logo pase" style={{ height: 28 }} />
                        </div>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    <List>
                        <ListItem onClick={handleItemClick("")} >
                            <ListItemButton >
                                <ListItemIcon>
                                    <HomeIcon />
                                </ListItemIcon>
                                <ListItemText primary="Inicio" />
                            </ListItemButton>
                        </ListItem>
                        {tieneCuentaRoles(["ADMIN_OPERADOR"]) &&
                            <ListItem onClick={handleItemClick("estanciasAbiertas")} >
                                <ListItemButton >
                                    <ListItemIcon>
                                        <Icon path={mdiCarClock} size={1} />
                                    </ListItemIcon>
                                    <ListItemText primary="Estancias abiertas" />
                                </ListItemButton>
                            </ListItem>
                        }
                    </List>
                    <div style={{ flexGrow: 1 }} />
                    <Typography variant='caption' align='center' sx={{ padding: 1 }}>{`v${metadataJson.version}b${metadataJson.build}`}</Typography>
                </Drawer>
                <Main open={open}>
                    <DrawerHeader />
                    <Outlet />
                </Main>
            </Box>
        </>
    );
}

export default MenuAppBar;